/* 
  API Documentations is in the following link :
  https://documenter.getpostman.com/view/8973992/UVyuTvXe
*/
import axios from 'axios';

// Base Url
// const baseUrl = 'http://localhost:8085';
// const baseUrl = 'https://water-tools-backend.server-jkt.fikrirp.com';
const baseUrl = 'https://api.water-tools.server-jkt.srsi.co.id/';

axios.defaults.withCredentials = true;
axios.defaults.baseURL = baseUrl;

// Questionnaire
export const allQuestion = `/question/all`;
export const questionCategory = `/question/categories`; // question category
export const questionsByCategoryId = (categoryId) =>
  `/question/category/${categoryId}`; // get question by categoryId

// Answers
export const saveAnswers = `/answer/bulk`; // post all question answers
export const answersBySiteId = (siteId) => `/answer/site/${siteId}`; // get all answers by siteId

// Login/Logout
export const loginApi = `/user/login`; // login
export const logoutApi = `/user/logout`; // logout

// Sites, Region, Subholding, Subsidiary
export const allSites = `/site/all`;
export const siteRegions = `/site/region`;
export const siteSubholdings = `/site/subholding`;
export const siteSubsidiaries = `/site/subsidiary`;

// Receiving Water Body
export const waterSourceApi = `/site/watersource`;
export const receivingWaterBodyApi = `/site/receivingwaterbody`;
